var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48456 24C4.48456 20.6898 12.2735 18.6667 16.1753 18.6667C20.0771 18.6667 27.866 20.6898 27.866 24V28H4.48456V24Z",
    fill: "#04B7B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1753 16C19.0449 16 21.3711 13.6122 21.3711 10.6667C21.3711 7.72113 19.0449 5.33333 16.1753 5.33333C13.3056 5.33333 10.9794 7.72113 10.9794 10.6667C10.9794 13.6122 13.3056 16 16.1753 16ZM16.1753 17.3333C19.7622 17.3333 22.6701 14.3485 22.6701 10.6667C22.6701 6.9848 19.7622 4 16.1753 4C12.5883 4 9.68042 6.9848 9.68042 10.6667C9.68042 14.3485 12.5883 17.3333 16.1753 17.3333Z",
    fill: "#04B7B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarCardIcon);
export default __webpack_public_path__ + "static/media/AvatarCardIcon.1f99213e6ac2b6d48da3f58a2de5afc9.svg";
export { ForwardRef as ReactComponent };